import { cn } from '../../lib/utils';

interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className }: SkeletonProps) => (
  <div
    className={cn(
      'animate-pulse rounded-md bg-gray-200',
      className
    )}
  />
);

// Stats: 3 cards compactos sem ícones
export const StatsSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="bg-white rounded-xl p-5 border border-gray-200">
        <Skeleton className="h-3 w-20 mb-2" />
        <Skeleton className="h-7 w-14" />
      </div>
    ))}
  </div>
);

// Filtros: segmented + dropdowns + pills
export const FiltersSkeleton = () => (
  <div className="space-y-4 mb-6">
    {/* Linha 1: segmented + mês + busca */}
    <div className="flex items-center gap-3">
      <Skeleton className="h-9 w-56 rounded-lg" />
      <Skeleton className="w-px h-6 bg-gray-200" />
      <Skeleton className="h-8 w-32 rounded-lg" />
      <Skeleton className="h-8 flex-1 min-w-[200px] rounded-lg" />
    </div>
    {/* Linha 2: pills */}
    <div className="flex items-center gap-1.5">
      <Skeleton className="h-3 w-16" />
      {[...Array(4)].map((_, i) => (
        <Skeleton key={`sev-${i}`} className="h-6 w-14 rounded-full" />
      ))}
      <Skeleton className="w-px h-4 mx-1" />
      <Skeleton className="h-3 w-12" />
      {[...Array(6)].map((_, i) => (
        <Skeleton key={`st-${i}`} className="h-6 w-20 rounded-full" />
      ))}
    </div>
  </div>
);

// Card do kanban
export const CardSkeleton = () => (
  <div className="bg-white rounded-xl p-4 border border-gray-100">
    <div className="space-y-3">
      {/* ID + data + badge severidade */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-3.5 w-12" />
          <Skeleton className="h-3 w-20" />
        </div>
        <Skeleton className="h-5 w-14 rounded-full" />
      </div>
      {/* Título */}
      <Skeleton className="h-4 w-4/5" />
      {/* Responsável */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-5 w-5 rounded-full" />
        <Skeleton className="h-3 w-28" />
      </div>
      {/* Status + Categoria */}
      <div className="flex gap-2">
        <Skeleton className="h-5 w-24 rounded-lg" />
        <Skeleton className="h-5 w-16 rounded-lg" />
      </div>
      {/* SLA */}
      <Skeleton className="h-7 w-full rounded-lg" />
    </div>
  </div>
);

// Kanban board
export const KanbanSkeleton = () => (
  <div className="space-y-6">
    {/* Header */}
    <div className="flex items-center justify-between">
      <Skeleton className="h-6 w-44" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-4 w-32" />
      </div>
    </div>

    {/* Colunas */}
    <div className="flex gap-6 overflow-x-auto pb-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex-1 min-w-80">
          {/* Header da coluna */}
          <Skeleton className="h-14 w-full rounded-t-xl" />
          {/* Cards */}
          <div className="bg-gray-50/50 border-l border-r border-b border-gray-200/50 rounded-b-xl min-h-96 p-4 space-y-4">
            {[...Array(i === 1 ? 4 : 2)].map((_, j) => (
              <CardSkeleton key={j} />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
